













import { Vue, Component, Prop } from 'vue-property-decorator';
import CabeceraModalCrearBase from '@/reusable/Modal/CabeceraModalCrearBase.vue';

@Component({
  components: { CabeceraModalCrearBase },
})
export default class CabeceraModalCrear extends Vue {
  @Prop({ required: true }) titulo: string;
}
